import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { SELECTED_FILTER_MAX_LINES } from 'store/constants/constants'
import { updateSelectedFilters } from 'store/actions/filters'
import SearchFilter from 'components/ui/SearchFilter'
import SelectedFilter from 'components/ui/SelectedFilter'
import FilterText from 'components/ui/FilterText'
import RemoveIcon from 'components/ui/RemoveIcon'
import SelectedFilterContainer from 'components/ui/SelectedFilterContainer'
import Dotdotdot from 'react-dotdotdot'
import CustomDropDownTreeSelect from 'components/ui/CustomDropdownTreeSelect'
import FilterTitle from 'components/ui/FilterTitle'

function MultiSelectPartnerType({
  type,
  values,
  showFilter,
  customTop,
  instant,
  selection,
  title
}) {
  const filters = useSelector(state => state.filters)
  const { currentSearchable } = filters
  const filterObject = filters.selectedFilters[currentSearchable][type]
  return (
    <PureMultiSelectPartnerType
      type={type}
      values={values}
      showFilter={showFilter}
      customTop={customTop}
      filterObject={filterObject}
      instant={instant}
      selection={selection}
      title={title}
    />
  )
}

const PureMultiSelectPartnerType = React.memo(function PureMultiSelectPartnerType({
  type,
  values,
  showFilter,
  customTop,
  filterObject,
  instant,
  selection,
  title
}) {
  const dispatch = useDispatch()
  const selectedValues = filterObject[values[0]].map(option => ({
    label: option,
    id: option
  }))

  const selectedOption = selectedValues.filter(s => s.id === 'private')
  const options = {
    label: 'Show only projects with private partners',
    value: 'private',
    expanded: true,
    checked: selectedOption.length > 0
  }

  const onChange = (currentNode, selectedNodes) => {
    const filterValue = selectedNodes.map(node => node.value)
    const data = {
      filterType: type,
      filterId: values[0],
      filterValue
    }
    dispatch(updateSelectedFilters(data))
  }

  function handleFilterRemove(filterId, filterValue, valueIsArray = false) {
    let resultingValue = null
    if (valueIsArray) {
      resultingValue = filterObject[filterId].filter(
        s => s.id !== filterValue.id || s !== filterValue
      )
    }
    const data = {
      filterType: type,
      filterId,
      filterValue: resultingValue
    }
    dispatch(updateSelectedFilters(data))
  }

  function renderSelectedValues() {
    return values.map(value => {
      if (filterObject[value]) {
        const filterValue = filterObject[value]
        if (filterValue instanceof Array) {
          return filterValue.map(v => (
            <SelectedFilterContainer className="selected-filters" key={v.id ? v.id : v}>
              <SelectedFilter isCapitalized>
                <FilterText title={v.label ? v.label : v}>
                  <Dotdotdot clamp={SELECTED_FILTER_MAX_LINES}>{v.label ? v.label : v}</Dotdotdot>
                </FilterText>
                <RemoveIcon
                  className="far fa-times"
                  onClick={() => handleFilterRemove(value, v, true)}
                />
              </SelectedFilter>
            </SelectedFilterContainer>
          ))
        }
      }
      return false
    })
  }

  return (
    <>
      {instant ? (
        <SearchFilter open={showFilter} customTop={customTop}>
          <CustomDropDownTreeSelect data={options} onChange={onChange} />
        </SearchFilter>
      ) : (
        <>
          {!selection ? (
            <SearchFilter open={showFilter} customTop={customTop}>
              <div className="sticky-container">
                {title ? <FilterTitle>{title}</FilterTitle> : null}
                <CustomDropDownTreeSelect data={options} onChange={onChange} />
              </div>
            </SearchFilter>
          ) : (
            <div className="selected-fl">{renderSelectedValues()}</div>
          )}
        </>
      )}
    </>
  )
})

MultiSelectPartnerType.propTypes = {
  type: PropTypes.string,
  filterData: PropTypes.array,
  values: PropTypes.array,
  title: PropTypes.string,
  showFilter: PropTypes.bool,
  customTop: PropTypes.string,
  instant: PropTypes.bool,
  selection: PropTypes.bool
}

PureMultiSelectPartnerType.propTypes = {
  type: PropTypes.string,
  filterData: PropTypes.object,
  values: PropTypes.array,
  title: PropTypes.string,
  showFilter: PropTypes.bool,
  customTop: PropTypes.string,
  filterObject: PropTypes.object,
  instant: PropTypes.bool,
  selection: PropTypes.bool
}

export default MultiSelectPartnerType
